// extracted by mini-css-extract-plugin
module.exports = {"alink":"Atag_alink__2oPEm","underline":"Atag_underline__VIWgU","blue":"Atag_blue__3odUr","red":"Atag_red__2_Q1n"};